<template>
  <el-card class="box-card">
    <div class="app_setting_cla">
      <div
        v-for="(item, index) in appSettingArray"
        class="app_setting_item"
        :key="index"
      >
        <div class="app_setting_title">
          <span style="width:280px;overflow: hidden;text-overflow: ellipsis;">{{
            item.name
          }}</span>
          <el-switch
            v-model="item.switchs"
            @change="item.fn(item.switchs)"
          ></el-switch>
        </div>
        <div class="app_setting_des">
          {{ $t('developer.pushDes') }}{{ item.des }}
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { updateAppOnCompanyTab } from '@/services/appManagerApi.js'
export default {
  props: {
    appInfo: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      appFnSwitch: false,
      appSettingArray: [
        {
          name: this.$t('developer.companyAdmin'),
          switchs: false,
          des: this.$t('developer.companySettingDes'),
          fn: this.companyOn
        }
      ]
    }
  },
  methods: {
    companyOn(val) {
      this.showLoad(this.$t('operation.saving'))
      let params = {
        id: this.appInfo.id,
        name: this.appInfo.name,
        companyManagerOn: val ? 1 : 0
      }
      updateAppOnCompanyTab(params)
        .then(data => {
          if (data.code === '00000000') {
            this.$emit('updateAppInfo')
            this.closeLoad()
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => this.errorMessage())
    }
  },
  mounted() {
    this.appSettingArray[0].switchs = this.appInfo.companyManagerOn === 1
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.app_setting_cla {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  .app_setting_item {
    width: 300px;
    margin: 0 10px 10px 0;
    border: 1px solid @fontColor4;
    border-radius: 4px;
    line-height: 28px;
    padding: 10px;
    box-shadow: @boxShadow;
  }
  .app_setting_title {
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
  }
  .app_setting_des {
    overflow: hidden;
    text-overflow: ellipsis;
    color: @fontColor3;
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; // 行数
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/appFnSetting.vue